<template>
  <div>
    <div class="snapshot-container" ref="faultTree">
      <div style="text-align: right; margin-bottom: 10px">
        <customize-button
          type="primary"
          @click="generatePDF"
          :loading="isDownloading"
        >
          Generate PDF
        </customize-button>
      </div>
      <el-row type="flex" :gutter="24">
        <el-col :span="12">
          <el-card shadow="never" :bordered="false" class="miniCard">
            <p class="cardHeader">SCORE</p>
            <process-bar
              :scaleArr="scaleArr"
              :total="10"
              :infoArr="infoArr"
              :scoreValue="scoreValue"
            />
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never" class="miniCard">
            <p class="cardHeader">CREDIT LINE UTILIZATION</p>
            <div class="processBox">
              <span class="warningLine" :style="warningWidth" />
              <el-progress
                :text-inside="true"
                :stroke-width="16"
                :percentage="utilPercentage"
                :format="formatPercentage"
                color="#4559FE"
              ></el-progress>
            </div>
            <div class="bottom-scale">
              <span class="scale" v-for="scale in utiScale" :key="scale">
                {{ scale }}
              </span>
            </div>
            <div class="infoBox" v-if="utiArr.length">
              <p v-for="item in utiArr" :key="item.key">
                <span class="infoTitle">{{ item.title }}:</span>
                <span class="infoValue">{{ item.value }}</span>
              </p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="24">
        <el-col :span="12" class="mt24">
          <el-card shadow="never" :bordered="false" class="miniCard">
            <p class="cardHeader">SCORE HISTORY</p>
            <v-chart :options="historyOptions" />
          </el-card>
        </el-col>
        <el-col :span="12" class="mt24">
          <el-card shadow="never" :bordered="false" class="miniCard">
            <p class="cardHeader">CREDIT TREND</p>
            <v-chart :options="chartOptions" />
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">KEY FACTS</p>
            <el-row :gutter="24">
              <el-col
                :span="8"
                v-for="item in companyInfo"
                :key="item.key"
                class="fact-col"
              >
                <span>{{ transKey2Title(item.key) }}：</span>
                <span>{{ item.value }}</span>
              </el-col>
              <el-col
                :span="8"
                v-for="item in companyDetailInfo"
                :key="item.key"
                class="fact-col"
              >
                <span>{{ transKey2Title(item.key) }}：</span>
                <span>{{ item.value }}</span>
              </el-col>
              <el-col
                :span="8"
                v-for="(item, index) in companyAccInfo"
                :key="index"
                class="fact-col"
              >
                <span>{{ transKey2Title(item.key) }}：</span>
                <span>{{ item.value }}</span>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <!--credit line part-->
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">CREDIT LINE</p>
            <div v-for="(item, index) in creditLine" :key="index">
              <el-row :gutter="24">
                <el-col :span="12" class="fact-col">
                  <span class="active-status" v-if="item.active === 1">
                    Active
                  </span>
                  <span>
                    Approved {{ item.type === 1 ? 'BAU' : 'UPLIFT' }} Line：
                  </span>
                  <span>{{ item.amount | formatAmount1 }}[USD]</span>
                </el-col>
                <el-col :span="12" class="fact-col">
                  <span>Approval Date：</span>
                  <span>{{ item.updateTime || item.finishTime }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12" class="fact-col">
                  <span>Effective Date：</span>
                  <span>{{ item.finishTime }}</span>
                </el-col>
                <el-col :span="12" class="fact-col">
                  <span>Expiry Date：</span>
                  <span>{{ item.indateEnd }}</span>
                </el-col>
                <el-col :span="12" class="fact-col">
                  <span>Partial Amount：</span>
                  <span>
                    {{ $utils.formatAmount1(item.partialAmount) }}
                  </span>
                </el-col>
                <!--                <el-col :span="12" class="fact-col">-->
                <!--                  <span>Group Credit Limit：</span>-->
                <!--                  <span>{{ groupCreditLimit }}</span>-->
                <!--                </el-col>-->
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!--Decision History -->
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">DECISION HISTORY</p>
            <table-view
              ref="tableList"
              :showPage="false"
              :tableModel="tableModel"
              :tableData="creditLineHistory || []"
              tableCardTitle="LIST"
            >
              <template v-slot:bpmId="{ tableRow }">
                <a
                  href="javascript:void(0)"
                  @click="handleClickHref(tableRow.row)"
                >
                  {{ tableRow.row.bpmId }}
                </a>
              </template>
            </table-view>
            <span class="moreRequest" @click="toSingle()">More Request...</span>
          </el-card>
        </el-col>
      </el-row>
      <!--Customer Aging Balance-->
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">CUSTOMER AGING BALANCE</p>
            <table-view
              ref="balanceTable"
              :showPage="false"
              :tableModel="balanceTbModel"
              :tableData="balanceTbData || []"
              tableCardTitle="LIST"
            ></table-view>
          </el-card>
        </el-col>
      </el-row>
      <!--Key Financial Ratios-->
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">KEY FINANCIAL RATIOS</p>
            <table-view
              ref="ratioTable"
              :showPage="false"
              :tableModel="ratioTbModel"
              :tableData="ratioTbData || []"
              tableCardTitle="LIST"
            />
          </el-card>
        </el-col>
      </el-row>
      <!--financial summary-->
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">FINANCIAL SUMMARY</p>
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="incomeTbModel"
              :tableData="incomeTbData || []"
              tableCardTitle="Income Statement"
            ></table-view>
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">FINANCIAL SUMMARY</p>
            <table-view
              ref="balanceTable"
              :tableModel="sheetTbModel"
              :tableData="sheetTbData || []"
              :showPage="false"
              tableCardTitle="Balance Sheet"
            ></table-view>
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="24">
        <el-col :span="24" class="mt24">
          <el-card shadow="never" :bordered="false">
            <p class="cardHeader">FINANCIAL SUMMARY</p>
            <table-view
              ref="cashTable"
              :showPage="false"
              :tableModel="cashTbModel"
              :tableData="cashTbData || []"
              tableCardTitle="Cash Flow"
            ></table-view>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCompanyInfo, getChartData, getCssDetail } from './api'
import processBar from './components/process-bar/process-bar'
import tableModel from './mixin/tableModel'
import dayjs from 'dayjs'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: 'snapshot',
  components: { processBar },
  mixins: [tableModel],
  data() {
    const balanceTbModel = [
      { prop: 'range', label: 'Display Label' },
      { prop: 'amount', label: 'Amount [USD]' },
      { prop: 'percentage', label: 'Percentage' },
    ]
    return {
      code: '',
      date: [],
      // score-process-bar
      scoreValue: 0,
      scaleArr: [0, 2.5, 5, 7.5, 10], // Score进度条刻度
      // utilization process-bar
      utiScale: ['0', '100k', '200k', '300k', '400k', '500k', '600k'],
      infoArr: [],
      infoArrKeys: ['executionDate', 'score', 'scoreCardStr'],
      utiArr: [],
      utilizationObj: {},
      historyOptions: {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
          },
        ],
        tooltip: {
          trigger: 'axis',
          // y 轴回显数据
          // axisPointer: {
          //   type: 'cross',
          //   label: {
          //     backgroundColor: '#6a7985',
          //   },
          // },
        },
      },
      // key fact -- company info
      companyAccInfo: {},
      companyAccInfoKeys: ['accountStatusStr'],
      companyDetailInfo: {},
      companyDetailInfoKeys: ['revenueLenovoLast12'],
      companyInfo: {},
      companyInfoKeys: [
        'code',
        'businessStr',
        'dunsNo',
        'regionStr',
        'countryStr',
        'registerDate',
        'paymentTermReq',
      ],
      creditLine: [],
      creditLineHistory: [],
      balanceTbModel,
      balanceTbData: [
        {
          id: 'currentBucket',
          range: 'Current bucket',
          amount: '',
          percentage: '',
        },
        {
          id: 'overdueOne',
          range: 'Overdue 1 - 30',
          amount: '',
          percentage: '',
        },

        {
          id: 'overdueThirty',
          range: 'Overdue 31 - 60',
          amount: '',
          percentage: '',
        },
        {
          id: 'overdueSixty',
          range: 'Overdue 61 - 90',
          amount: '',
          percentage: '',
        },
        {
          id: 'overdueNinety',
          range: 'Overdue 91 - 180',
          amount: '',
          percentage: '',
        },
        {
          id: 'overdueHundredEighty',
          range: '180+ Overdue',
          amount: '',
          percentage: '',
        },
        {
          id: 'amountBacklog',
          range: 'Backlog',
          amount: '',
          percentage: '',
        },
      ],
      ratioTbModel: [],
      ratioTbData: [],
      // summary - income
      incomeTbModel: [],
      incomeTbData: [],
      // summary - balance
      sheetTbModel: [],
      sheetTbData: [],
      // summary - cash flow
      cashTbModel: [],
      cashTbData: [],
      showMoreRequest: false,
      showRationsKeys: [
        'c18',
        'c19',
        'c20',
        'c21',
        'c26',
        'c29',
        'c35',
        'c37',
        'c38',
        'c41',
        'c43',
        'c47',
        'c49',
      ],
      showIncomeKeys: ['c20', 'c25', 'c49', 'c67'],
      showBalanceKeys: ['c34', 'c63', 'c80', 'c94', 'c106'],
      chartOptions: {
        grid: {
          left: '1%',
          right: '1%',
          bottom: '10%',
          containLabel: true,
        },
        // x 轴
        xAxis: {
          type: 'category',
          // 默认是 true x 轴两侧会有一些距离，
          boundaryGap: false,
          data: [],
        },
        // y 轴
        yAxis: {
          type: 'value',
        },
        // 系列对应图表
        series: [
          {
            data: [],
            type: 'line',
            name: 'Credit Line',
          },
          {
            data: [],
            type: 'line',
            name: 'Soft Collateral',
          },
          {
            data: [],
            type: 'line',
            name: 'Hard Collateral',
          },
          {
            data: [],
            type: 'line',
            name: 'Insurance',
          },
        ],
        tooltip: {
          trigger: 'axis',
          name: 'totalCollateralAmount',
        },
      },
      isDownloading: false,
      groupCreditLimit: null,
    }
  },
  computed: {
    utilPercentage: function () {
      if (this.utilizationObj.utilization) {
        return parseFloat(this.utilizationObj.utilization)
      } else {
        return 0
      }
    },
    warningWidth: function () {
      if (this.utilizationObj.creditLimit) {
        return `left: ${Math.ceil(
          (this.utilizationObj.creditLimit / 1000 / 600) * 100 - 2.23,
        )}%`
      } else {
        return 'display: none'
      }
    },
  },
  mounted() {
    this.initTime()
    this._getCompanyInfo()
    this._getChartData()
    // this.getGroupcreditLimit()
  },
  methods: {
    // async getGroupcreditLimit() {
    //   try {
    //     const res = await request.get(
    //       `/customer-api/company-relation/relation/creditLimit?companyId=${this.$route.params.customerId}`,
    //     )
    //     this.groupCreditLimit = this.$utils.formatAmount(res)
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    formatPercentage() {
      return this.utilizationObj.utilization
    },
    generatePDF() {
      let ref = this.$refs.faultTree // 截图区域
      const title = 'default'
      html2canvas(ref, {
        backgroundColor: '#f4f3f9',
      })
        .then(canvas => {
          // canvas宽度
          let contentWidth = canvas.width
          // canvas高度
          let contentHeight = canvas.height
          // 一页pdf html页面生成的canvas高度
          let pageHeight = (contentWidth / 592.28) * 841.89
          let leftHeight = contentHeight
          let position = 0
          // a4纸的尺寸[592.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          let imgWidth = 595.28
          let imgHeight = (592.28 / contentWidth) * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          // 当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              // 避免添加空白页
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        })
        .catch(() => {
          this.$message({
            message: 'Images generated failure',
            type: 'error',
          })
        })
    },
    toSingle() {
      this.$router.push({
        path: '/credit-management/all-credit-history/single-all',
        query: { code: this.code },
      })
    },
    initTime() {
      const date = dayjs().format('YYYY-MM-DD')
      const startDate = dayjs().subtract(1, 'year').format('YYYY-MM-DD')
      this.date = [startDate, date]
    },
    async handleClickHref(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (tableRow.sourceStr === 'CSS') {
        const params = {
          bpmId: tableRow.bpmId || this.$storage.getItem('bpmId'),
        }
        const { running, creditInfo, additionalConditionsVOList, process } =
          await getCssDetail(params)
        // 根据status跳转;1为pending状态(跳到final);2为完成; 6为condition approved状态(跳到二次审核)
        if (
          (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
          (creditInfo.decisionType === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          (creditInfo.decisionType === 4 &&
            creditInfo.status === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1)
        ) {
          // 单比审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else if (creditInfo.status === 6) {
          // 二次审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-second-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          // 最终审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-final-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        }
        return
      } else {
        let routeUrl = this.$router.resolve({
          path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    async _getChartData() {
      try {
        const params = {
          companyId: this.$route.params.customerId,
          endTime: '',
          startTime: '',
        }
        if (this.date && this.date.length) {
          params.startTime = this.date[0]
          params.endTime = this.date[1]
        }
        const chartData = await getChartData(params)
        this.chartOptions.xAxis.data = chartData.trend.map(item => item.time)
        this.chartOptions.series[0].data = chartData.trend.map(
          item => item.validAmount,
        )
        this.chartOptions.series[1].data = chartData.trend.map(
          item => item.softCollateralAmount,
        )
        this.chartOptions.series[2].data = chartData.trend.map(
          item => item.hardCollateralAmount,
        )
        this.chartOptions.series[3].data = chartData.trend.map(
          item => item.totalCollateralAmount,
        )
      } catch (err) {
        console.error(err)
      }
    },
    async _getCompanyInfo() {
      const res = await getCompanyInfo(this.$route.params.customerId)
      // score history 折线图数据
      this.historyOptions = {
        ...this.historyOptions,
        xAxis: {
          ...this.historyOptions.xAxis,
          data: res.creditScoreCardHistoryVOS.map(item => item.executionDate),
        },
        series: [
          {
            data: res.creditScoreCardHistoryVOS.map(item => item.score),
            type: 'line',
          },
        ],
      }
      // Score 视图
      this.infoArr = this.handleScore(
        res.creditScoreCardPageVO,
        this.infoArrKeys,
      )
      // utilization 视图'
      this.utiArr = this.handleUtilization(res.creditLineUtilizationVO)
      this.utilizationObj = res.creditLineUtilizationVO
      const base = Math.floor(res.creditLineUtilizationVO.creditLimit / 5)
      this.utiScale = []
      for (let i = 0; i <= 5; i++) {
        if (i === 5) {
          this.utiScale.push(
            `${Math.floor(res.creditLineUtilizationVO.creditLimit) / 1000}k`,
          )
        } else {
          this.utiScale.push(`${Math.floor(base / 1000) * i}k`)
        }
      }
      // key fact
      this.companyAccInfo = this.handleKeyFact(
        res.companyAccountVO,
        this.companyAccInfoKeys,
      )
      // companyDetailInfo
      this.companyDetailInfo = this.handleCompanyDetail(
        res.companyDetailVO,
        this.companyDetailInfoKeys,
      )
      // ...company Info
      this.companyInfo = this.handleCompanyInfo(
        res.companyInfoVO,
        this.companyInfoKeys,
      )
      this.code = this.companyInfo[0].value
      // Credit line
      this.creditLine = res.creditBpmAmountEffectiveVOS
      // credit line history - 只显示前三个，如果超出三个下面会有more request文字，点击跳转 4-1
      this.creditLineHistory = res.creditBpmHistoryVOList.slice(0, 3)
      if (res.creditBpmHistoryVOList.length > 3) {
        this.showMoreRequest = true
      }
      // Customer Aging Balance
      this.balanceTbData.forEach(item => {
        item.amount = res.customerAr && res.customerAr[item.id]
        item.amount = this.$utils.formatAmount(item.amount)
        item.percentage =
          res.customerAr && res.customerAr[`${item.id}Rate`] + '%'
      })
      // ⬇⬇⬇⬇ finance ratios
      // 处理key financial ratios只显示部分内容
      const _financeRatios =
        res.financeRatios &&
        res.financeRatios.map(item => {
          const _data = {}
          for (const key of this.showRationsKeys) {
            if (Object.keys(item.data).indexOf(key) !== -1) {
              _data[key] = item.data[key]
            }
          }
          return { ...item, data: _data }
        })
      this.ratioTbModel = this.transTbModel(_financeRatios) // 表头
      this.ratioTbData = this.transTbData(_financeRatios, 'financialRatios')
      // ⬇⬇⬇⬇ income statement
      // 处理res.financeIncomes只显示部分内容
      const _financeIncomes =
        res.financeIncomes &&
        res.financeIncomes.map(item => {
          const _data = {}
          for (const key of this.showIncomeKeys) {
            if (Object.keys(item.data).indexOf(key) !== -1) {
              _data[key] = item.data[key]
            }
          }
          return { ...item, data: _data }
        })
      this.incomeTbModel = this.transTbModel(_financeIncomes)
      this.incomeTbData = this.transTbData(_financeIncomes, 'financialIncomes')
      // ⬇⬇⬇⬇ Balance Sheet
      this.sheetTbModel = this.transTbModel(res.financeBalances)
      this.sheetTbData = this.transTbData(res.financeBalances, 'balanceSheet')
      // ⬇⬇⬇⬇ cash flow table
      this.cashTbModel = this.transTbModel(res.cashflows)
      this.cashTbData = this.transTbData(res.cashflows, 'cashFlow')
    },
    // 由于字段中存在null的情况，需要抽出function来做容错处理（在逻辑中直接Object.keys(null)会报错并且不方便处理）
    handleScore(sourceData, keys = []) {
      if (!sourceData) return
      const _infoArr = []
      Object.keys(sourceData).map(key => {
        if (keys.indexOf(key) !== -1) {
          if (key === 'score') {
            _infoArr.push({
              title: this.transKey2Title(key),
              value:
                sourceData[key] < 0
                  ? 0
                  : sourceData[key] > 10
                  ? 10
                  : sourceData[key],
            })
            this.scoreValue =
              sourceData[key] < 0
                ? 0
                : sourceData[key] > 10
                ? 10
                : sourceData[key]
          } else {
            _infoArr.push({
              title: this.transKey2Title(key),
              value: sourceData[key],
            })
          }
        }
      })
      return _infoArr
    },
    // 抽出function来做容错处理
    handleUtilization(sourceData) {
      sourceData.utilization = `${Number(
        sourceData.utilization.split('%')[0],
      )}%`
      if (!sourceData) return
      const _utiArr = []
      Object.keys(sourceData).map(key => {
        _utiArr.push({
          key: key,
          title: this.transKey2Title(key),
          value:
            key === 'utilization'
              ? sourceData[key]
              : this.$utils.formatAmount1(sourceData[key]),
        })
      })
      return _utiArr
    },
    // ...
    handleKeyFact(sourceData, keys = []) {
      if (!sourceData) return
      const _companyAccInfo = []
      Object.keys(sourceData).map(key => {
        if (keys.indexOf(key) !== -1) {
          _companyAccInfo.push({
            key: key,
            value: sourceData[key],
          })
        }
      })
      return _companyAccInfo
    },
    // ...
    handleCompanyDetail(sourceData, keys) {
      if (!sourceData) return
      const _companyDetailInfo = []
      Object.keys(sourceData).map(key => {
        if (keys.indexOf(key) !== -1) {
          _companyDetailInfo.push({
            key: key,
            value: sourceData[key],
          })
        }
      })
      return _companyDetailInfo
    },
    // ...
    handleCompanyInfo(source, keys) {
      if (!source) return
      const _companyInfo = []
      Object.keys(source).map(key => {
        if (keys.indexOf(key) !== -1) {
          _companyInfo.push({
            key: key,
            value: source[key],
          })
        }
      })
      return _companyInfo
    },
    // 因为多个表格使用了同样表头，抽出function
    transTbModel(sourceData) {
      if (!sourceData) return []
      return [{ label: '', prop: 'name' }].concat(
        sourceData.map(item => ({
          label: `Annual ${item.year}`,
          prop: `year${item.year}`,
        })),
      )
    },
    // 根据数据转化成需要的el-table数据，抽出function
    transTbData(sourceData, dataType) {
      if (!sourceData) return
      const len = Object.keys(sourceData[0].data)?.length
      const arr = []
      for (let i = 0; i < len; i++) {
        const obj = {}
        for (let j = 0; j < sourceData.length; j++) {
          const key = Object.keys(sourceData[j].data)[i]
          obj.name = this.transKey2Title(key, dataType)
          // obj[`year${sourceData[j].year}`] = this.$utils.formatAmount(
          //   sourceData[j].data[key],
          // )
          // obj[`year${sourceData[j].year}`] = sourceData[j].data[key]
          obj[`year${sourceData[j].year}`] = this.$utils.formatAmount2(
            sourceData[j].data[key],
          )
        }
        if (obj.name) {
          arr.push(obj)
        }
      }
      return arr
    },
    transKey2Title(key, dataType) {
      if (!dataType) {
        switch (key) {
          case 'score':
            return 'Score'
          case 'scoreCardStr':
            return 'Name'
          case 'executionDate':
            return 'Date Of Score'
          case 'creditLimit':
            return 'Credit Limit ( in USD )'
          case 'utilization':
            return '% Utilization'
          case 'clUtilized':
            return 'CL Utilized ( in USD )'
          case 'code':
            return 'Customer #'
          case 'businessStr':
            return 'Business Type'
          case 'dunsNo':
            return 'Duns Number'
          case 'accountStatusStr':
            return 'Account Status'
          case 'revenueLenovoLast12':
            return 'Annual Revenue'
          case 'countryStr':
            return 'Country'
          case 'registerDate':
            return 'Customer Since'
          case 'paymentTermReq':
            return 'Payment Term(Days)'
          case 'regionStr':
            return 'Region'
        }
      }
      if (dataType === 'financialRatios') {
        switch (key) {
          // ratios
          case 'c18':
            return 'Net Profit Margin'
          case 'c19':
            return 'Gross Profit Margin'
          case 'c20':
            return 'Return on Assets'
          case 'c21':
            return 'Return on Tangible Equity'
          case 'c22':
            return 'Non Operating Income / Expense as % Sales'
          case 'c23':
            return 'Total Operating Expenses as % of Sales'
          case 'c24':
            return 'Operating Income as % of Sales'
          case 'c25':
            return 'Gross Profit'
          case 'c26':
            return 'Accounts Receivable Turnover'
          case 'c27':
            return 'Inventory Turnover'
          case 'c28':
            return 'Current Asset Turnover'
          case 'c29':
            return 'Total Asset Turnover'
          case 'c30':
            return 'Accounts Payable Turnover'
          case 'c31':
            return 'Accounts Payable/Net Revenue'
          case 'c32':
            return 'Accounts Receivable Days'
          case 'c33':
            return 'Inventory Days'
          case 'c34':
            return 'Accounts Payable Days'
          case 'c35':
            return 'Net Working Capital Cycle'
          case 'c36':
            return 'Insurance'
          case 'c37':
            return 'Current Ratio'
          case 'c38':
            return 'Quick Ratio'
          case 'c39':
            return 'Net Working Capital'
          case 'c40':
            return 'Printing and Stationery'
          case 'c41':
            return 'Debt to Tangible Equity'
          case 'c42':
            return 'Debt Ratio'
          case 'c43':
            return 'Debt/Capitalization'
          case 'c44':
            return 'Curr. Liab./Total Liab.'
          case 'c45':
            return 'Curr. Liab/Total Liab. & Equity'
          case 'c46':
            return 'Leverage Multiplier'
          case 'c47':
            return 'Interest Coverage'
          case 'c48':
            return 'Interest Expense as % of Sales'
          case 'c49':
            return 'Cash Flow Coverage'
          case 'c50':
            return 'Debt Services Ratio'
          case 'c51':
            return 'Trade Payable Coverage'
          case 'c52':
            return 'Interest Income'
          case 'c53':
            return 'Sustainable Growth Model I'
          case 'c54':
            return 'Sustainable Growth Model II'
          case 'c55':
            return 'Sustainable Growth Model III'
          case 'c56':
            return 'Z-Score'
          case 'c57':
            return 'Income From Oper. Bef. Income Taxes'
          case 'c58':
            return 'Income Tax'
          case 'c59':
            return 'Operating Profit After Tax'
          case 'c60':
            return 'Minority Interest in consolidated subsidiaries'
          case 'c62':
            return 'Extraordinary Gains'
          case 'c63':
            return '(Less) Extraordinary Losses'
          case 'c64':
            return 'Other Custom Field 1'
          case 'c65':
            return 'Other Custom Field 2'
          case 'c66':
            return 'Total Extraordinary Items'
          case 'c67':
            return 'Net Income'
          case 'c68':
            return 'Dividends Paid'
          case 'd27':
            return 'Net Cash provided (used) by Operating Activities'
          case 'd32':
            return 'Net Cash provided (used) by Investing Activities'
          case 'd41':
            return 'Net Cash provided (used) by Financing Activities'
          case 'd43':
            return 'Net Cash provided (used) by all above activities'
        }
      }
      if (dataType === 'financialIncomes') {
        switch (key) {
          case 'c20':
            return 'Total Sales'
          case 'c49':
            return 'Optg. Income Bef. Other Inc/Exp. Int. and Taxes'
          case 'c25':
            return 'Gross Profit'
          case 'c67':
            return 'Net Income'
        }
      }
      if (dataType === 'balanceSheet') {
        switch (key) {
          case 'c34':
            return 'Total Current Assets'
          case 'c63':
            return 'Total Assets'
          case 'c80':
            return 'Total Current Liabilities'
          case 'c94':
            return 'Total Liabilities'
          case 'c106':
            return "Total Owner's Equity"
        }
      }
      if (dataType === 'cashFlow') {
        switch (key) {
          case 'd27':
            return 'Net Cash provided (used) by Operating Activities'
          case 'd32':
            return 'Net Cash provided (used) by Investing Activities'
          case 'd41':
            return 'Net Cash provided (used) by Financing Activities'
          case 'd43':
            return 'Net Cash provided (used) by all above activities'
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
.customize-button {
  border: none;
  border-radius: 27px;
  cursor: pointer;
  box-sizing: border-box;
}
.snapshot-container {
  //background-color: #00d0b5;
  .moreRequest {
    cursor: pointer;
    color: blue;
    font-size: 14px;
  }
  .mt24 {
    margin-top: 24px;
  }

  .rowCard {
    margin-top: 24px;
  }

  .cardHeader {
    font-size: 16px;
    color: #3a3f63;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  .miniCard {
    min-height: 253px;

    .processBox {
      position: relative;

      .warningLine {
        position: absolute;
        display: inline-block;
        width: 2px;
        height: 16px;
        background: #ff2855;
        z-index: 999;
        top: 1px;
      }
    }

    .infoBox {
      display: flex;
      flex-direction: column;
      margin-top: 26px;

      p {
        display: flex;
        margin-bottom: 12px;

        .infoTitle {
          font-size: 14px;
          color: #2b2f42;
          letter-spacing: 0;
          text-align: right;
          font-weight: 700;
        }

        .infoValue {
          font-size: 14px;
          color: #3a3f63;
          letter-spacing: 0;
          font-weight: 400;
          margin-left: 8px;
        }
      }
    }
  }

  .bottom-scale {
    display: flex;
    justify-content: space-between;

    .scale {
      position: relative;
      font-size: 12px;
      color: #3a3f63;
      letter-spacing: 0;
      margin-top: 12px;

      &::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 6px;
        //background: #e3e7f2;
        background-color: #e3e7f2;
        position: absolute;
        bottom: 15px;
        left: 70%;
      }
    }
  }

  .fact-col {
    height: 30px;
    line-height: 30px;
    font-size: 14px;

    .active-status {
      display: inline-block;
      width: 53px;
      height: 24px;
      background: #4458fe;
      border-radius: 16px;
      font-size: 12px;
      text-align: center;
      line-height: 24px;
      color: white;
    }
  }
}
.echarts {
  width: 100%;
}
</style>
